/**
 * The four services shown in the Bekebi Portal (the service layer above the infrastructure):
 * Cloud Server (BekebiCloud), Mail Server, Storage Bucket, Website. Stored values are internal
 * identifiers; the labels are the names everyone sees.
 */
export const SERVICE_TYPES = ['cloud_server', 'mail_server', 'storage_bucket', 'website'] as const;
export type ServiceType = (typeof SERVICE_TYPES)[number];

export const SERVICE_TYPE_LABELS: Record<ServiceType, string> = {
  cloud_server: 'Cloud Server',
  mail_server: 'Mail Server',
  storage_bucket: 'Storage Bucket',
  website: 'Website',
};

/**
 * Services that have a health state. The Storage Bucket has none (director, 2026-11-02; ST-2): it
 * is shown by its space used against its plan and by its backups, not as healthy or unknown, and it
 * is not counted in the health summaries.
 */
export function hasServiceHealth(type: ServiceType): boolean {
  return type !== 'storage_bucket';
}
